import type { LabeledValue } from "@/components/atomic-crm/types";
import { isNaiuTenant } from "./tenant";

export const NAIU_ORIGIN_CHANNELS: LabeledValue[] = [
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "facebook", label: "Facebook" },
  { value: "blog", label: "Blog / SEO" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "lead_magnet", label: "Lead magnet" },
  { value: "referral", label: "Referido" },
  { value: "manual", label: "Manual" },
];

export const ORIGIN_CHANNELS: LabeledValue[] = [
  { value: "prospector_maps", label: "CSV / Prospector Maps" },
  { value: "inbound_web", label: "Web ARKA" },
  { value: "inbound_whatsapp", label: "WhatsApp / Chasqui" },
  { value: "inbound_instagram", label: "Instagram / Chasqui" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "referral", label: "Referido" },
  { value: "call", label: "Llamada" },
  { value: "visit", label: "Visita" },
  { value: "manual", label: "Manual" },
];

export const INBOUND_ORIGIN_VALUES = new Set([
  "inbound_web",
  "inbound_whatsapp",
  "inbound_instagram",
  "linkedin",
  "referral",
]);

export function getOriginChannels(): LabeledValue[] {
  return isNaiuTenant() ? NAIU_ORIGIN_CHANNELS : ORIGIN_CHANNELS;
}

export function findOriginLabel(value: string | null | undefined): string {
  if (!value) {
    return "";
  }
  const channels = [...ORIGIN_CHANNELS, ...NAIU_ORIGIN_CHANNELS];
  return channels.find((channel) => channel.value === value)?.label ?? value;
}
